<nav class="navbar navbar-vertical">
  <div class="navbar-vertical-content scrollbar pt-4">
    <!-- Approvals -->
    <ul class="navbar-nav flex-column">
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/approvals"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"><span class="fas fa-bell"></span></span>
          <span class="nav-link-text">{{
            "admin.sideNav.approvals" | translate
          }}</span>
        </a>
      </li>
    </ul>

    <!-- Projects -->
    <!-- TODO: Use @for to iterate items instead of repetition. -->
    <div
      class="navbar-vertical-label d-flex align-items-center px-3 mb-2 mt-4 text-600"
    >
      <span>
        {{ "admin.sideNav.projects.projectsLabel" | translate }}
      </span>
      <div class="navbar-vertical-divider flex-1 ms-2"></div>
    </div>

    <ul class="navbar-nav flex-column">
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/projects"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"
            ><span class="fas fa-building"></span
          ></span>
          <span class="nav-link-text">{{
            "admin.sideNav.projects.allProjects" | translate
          }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/project-ideas"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"
            ><span class="fas fa-lightbulb"></span
          ></span>
          <span class="nav-link-text">
            {{ "admin.sideNav.projects.pendingProjectIdeas" | translate }}</span
          >
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/investments"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"
            ><span class="fas fa-chart-line"></span
          ></span>
          <span class="nav-link-text">
            {{ "admin.sideNav.projects.investments" | translate }}</span
          >
        </a>
      </li>
    </ul>

    <!-- Entities -->
    <div
      class="navbar-vertical-label d-flex align-items-center px-3 mb-2 mt-4 text-600"
    >
      <span>
        {{ "admin.sideNav.entities.entitiesLabel" | translate }}
      </span>
      <div class="navbar-vertical-divider flex-1 ms-2"></div>
    </div>

    <ul class="navbar-nav flex-column">
      <li class="nav-item">
        <a class="nav-link" routerLink="/admin/users" routerLinkActive="active">
          <span class="nav-link-icon"><span class="fas fa-user"></span></span>
          <span class="nav-link-text">{{
            "admin.sideNav.entities.users" | translate
          }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/legal-entities"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"
            ><span class="fas fa-industry"></span
          ></span>
          <span class="nav-link-text">{{
            "admin.sideNav.entities.legalEntities" | translate
          }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/investors"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"
            ><span class="fas fa-hard-hat"></span
          ></span>
          <span class="nav-link-text">{{
            "admin.sideNav.entities.investors" | translate
          }}</span>
        </a>
      </li>
      <!-- <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/contacts"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"
            ><span class="fas fa-industry"></span
          ></span>
          <span class="nav-link-text">{{
            "admin.sideNav.entities.contacts" | translate
          }}</span>
        </a>
      </li> -->
    </ul>

    <!-- Database Management -->
    <div
      class="navbar-vertical-label d-flex align-items-center px-3 mb-2 mt-4 text-600"
    >
      <span>
        {{
          "admin.sideNav.databaseManagement.databaseManagementLabel" | translate
        }}
      </span>
      <div class="navbar-vertical-divider flex-1 ms-2"></div>
    </div>

    <ul class="navbar-nav flex-column">
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/database/companyType"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"><span class="fas fa-city"></span></span>
          <span class="nav-link-text">{{
            "admin.sideNav.databaseManagement.companyTypes" | translate
          }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/database/country"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"><span class="fas fa-flag"></span></span>
          <span class="nav-link-text">{{
            "admin.sideNav.databaseManagement.countries" | translate
          }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/database/currency"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"
            ><span class="fas fa-money-bill"></span
          ></span>
          <span class="nav-link-text">{{
            "admin.sideNav.databaseManagement.currencies" | translate
          }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/database/legalEntityRole"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"
            ><span class="fas fa-quote-left"></span
          ></span>
          <span class="nav-link-text">{{
            "admin.sideNav.databaseManagement.legalEntityRoles" | translate
          }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/database/nameTitle"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"><span class="fas fa-users"></span></span>
          <span class="nav-link-text">{{
            "admin.sideNav.databaseManagement.nameTitles" | translate
          }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/database/personRole"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"
            ><span class="fas fa-layer-group"></span
          ></span>
          <span class="nav-link-text">{{
            "admin.sideNav.databaseManagement.personRoles" | translate
          }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/database/projectClassification"
          routerLinkActive="active"
        >
          <span class="nav-link-icon"><span class="fas fa-star"></span></span>
          <span class="nav-link-text">{{
            "admin.sideNav.databaseManagement.projectClassification" | translate
          }}</span>
        </a>
      </li>
    </ul>
  </div>
</nav>
